
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-commercial-vehicles/Altigreen",
      function () {
        return require("private-next-pages/electric-commercial-vehicles/Altigreen/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/electric-commercial-vehicles/Altigreen"])
      });
    }
  